import {
  getArrivalDate,
  getCheapestService,
  getQuickestService,
} from '../containers/ServiceSelection/utils';
import { Shipment, Service, Parcel } from '../types/common';
import Tracking from '../utils/tracking';
import { getCourier, getOrderValue } from '../utils/helpers';
import { getWeightCategory, getDimenstions, shipmentMap } from './utils';
import { getParcelsActualWeight, getParcelsVolumetricWeight } from '../containers/Packages/utils';

export const sendOriginRegionChanged = (country: string): void => {
  Tracking.event('Origin region changed', { changed_to: country });
};

export const sendDestinationRegionChanged = (country: string): void => {
  Tracking.event('Destination region changed', { changed_to: country });
};

export const sendParcelSizeChanged = (packageSize: Parcel): void => {
  Tracking.event('Parcel size changed', {
    changed_to: getDimenstions(packageSize),
  });
};

export const sendItemFormViewed = (): void => {
  Tracking.event('Item form viewed');
};

export const sendItemUpdated = (description: string): void => {
  Tracking.event('Item updated', {
    category: 'Others',
    description: description,
  });
};

export const sendItemDeleted = (description = ''): void => {
  Tracking.event('Item deleted', {
    category: 'Others',
    description,
  });
};

export const sendServiceOptionsViewed = (filter: string): void => {
  Tracking.event('Service options viewed', { filter });
};

export const sendServiceChanged = (service: string, options: Service[]): void => {
  const quickestService = getQuickestService(options);
  const cheapestService = getCheapestService(options);
  const fast = quickestService?.slug;
  const cheap = cheapestService?.slug;

  Tracking.event('Service changed', {
    changed_to: service,
    preference: service === fast ? 'fast' : service === cheap ? 'cheap' : 'custom',
  });
};

export const sendQuotationUpdated = (shipment: Shipment, selectedService: Service | null): void => {
  const { originCountry, destinationCountry, service, parcels, type } = shipment;
  const courier = getCourier(service);
  const { maxDeliveryDays } = selectedService || {};

  Tracking.event(
    'Quotation updated',
    {
      arrival_date_projected: getArrivalDate(maxDeliveryDays).toISOString(),
      courier,
      destination: destinationCountry,
      origin: originCountry,
      parcel_count: parcels.length,
      status: 'collect',
      weight_actual: getParcelsActualWeight(parcels) * 1000,
      weight_volumetric: getParcelsVolumetricWeight(parcels) * 1000,
      shipment_type: shipmentMap[type],
    },
    true,
  );
};

/* Segment e-commerce events */
export const sendProductAdded = (shipment: Shipment, selectedService: Service | null): void => {
  const { originCountry, destinationCountry, service, parcels } = shipment;
  const { naturalAmount } = selectedService || {};
  const weight = getParcelsActualWeight(parcels);
  const category = getWeightCategory(weight);

  Tracking.event('Product added', {
    product_id: `${originCountry}-${destinationCountry}`,
    sku: `${originCountry}-${destinationCountry}`,
    brand: service,
    category,
    name: `${originCountry}-${destinationCountry}`,
    price: getOrderValue(naturalAmount),
    quantity: 1,
  });
};
